var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"content"},[_vm._v(" Your data has been submitted successfully."),_c('br'),_vm._v(" You may now close this window. ")])])])
}]

export { render, staticRenderFns }